export default {
      id: "make-copy-usage",
      viewBox: "0 0 13 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#make-copy-usage",
      toString: function () {
        return this.url;
      }
    }